export function sort(arr, key = 'name') {
  return arr.sort((a, b) => a[key].localeCompare(b[key]));
}
